import React from "react";
import PortalLogoutButton, {
  PortalLogoutButtonProps,
} from "../PortalLogoutButton/PortalLogoutButton";
import { useAdvisorLogout } from "../../hooks/useAdvisorLogout";

// ITAM-2887: the advisor's logout control (nav drawer and account panel): the
// shared portal button over `useAdvisorLogout`, which supplies the gates
// (disabled during a live call, confirm before discarding a consult draft,
// bounded availability pause before the session clears).
const AdvisorLogoutButton: React.FC<Omit<PortalLogoutButtonProps, "control">> = (
  props,
) => {
  const control = useAdvisorLogout();
  return <PortalLogoutButton control={control} {...props} />;
};

export default AdvisorLogoutButton;
